import { HierarchyContextProps, IHierarchyActionRemoveDomainReplacement } from "../interface";
import { hcr_updateChangedFlag } from "./hcr_updateChangedFlag";

/**
 * Removes a domain replacement from the current hierarchy.
 *
 * @param state - The current hierarchy context state.
 * @param action - The remove-domain-replacement action to apply.
 * @returns The updated hierarchy context state.
 */
export const hcr_removeDomainReplacement = (
  state: HierarchyContextProps,
  action: IHierarchyActionRemoveDomainReplacement,
): HierarchyContextProps => {
  if (!state.hierarchy)
    throw new Error(`hierarchyContextReducer: ${action.operation}: Hierarchy not assigned`);

  const ix = state.hierarchy.domainReplacements.findIndex(
    (dr) => dr.airid === action.domainReplacement.airid,
  );
  if (ix > -1) {
    return hcr_updateChangedFlag(
      {
        ...state,
        hierarchy: {
          ...state.hierarchy,
          domainReplacements: state.hierarchy.domainReplacements.filter(
            (dr) => dr.airid !== action.domainReplacement.airid,
          ),
        },
      },
      action,
    );
  }

  return state;
};
